import { JagListView } from '../JagListView';
import { JagListViewContextProvider } from '../JagListViewContext';

export const JagList = () => (
  <JagListViewContextProvider>
    <JagListView />
  </JagListViewContextProvider>
);
